import ENV from "../env";
import { api as apiCore } from "@s-e/kodema-core";

export const api = apiCore(fetch)(`${ENV.QUERY_PROTOCOL}${ENV.API_ENDPOINT}`);
export const apiQuery = api(undefined);
